module.exports = __webpack_public_path__ + "static/img/buzzy.e74aa92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/buzzy.jpg
// module id = Fmya
// module chunks = 1